import PPSummaryBox from "./PPSummaryBox";
import "../dashboard-sections.css";

const DUMMY = [
  { icon: "⚙️", label: "Strips KG",  value: 12000, note: "4.2% vs yesterday", noteType: "up"      },
  { icon: "✕",  label: "Cheeks KG",  value: 10500, note: "On target",          noteType: "neutral" },
  { icon: "📋", label: "Total KG",   value: 22500, note: "Updated 5m ago",     noteType: "neutral" },
  { icon: "📋", label: "Pasting KG", value: 1500,  note: "10% waste ratio",    noteType: "down"    },
  { icon: "🗑️", label: "Trash",      value: 2000,  note: "8.8% waste ratio",   noteType: "down", danger: true },
];

const PackingMetricCards = ({ cards = DUMMY, isLoading = false }) => (
  <div className="pp-metric-row">
    {cards.map((card, i) => (
      <PPSummaryBox key={i} {...card} isLoading={isLoading} />
    ))}
  </div>
);

export default PackingMetricCards;
